/*eslint-disable */
import axios from 'axios';



function generate_uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var uuid = (Math.random() * 16) | 0,
      v = c == 'x' ? uuid : (uuid & 0x3) | 0x8;
    return uuid.toString(16);
  });
}

export async function client(
  endpoint: string,
  { requestType, body, ...customConfig }: any = {},
  apiUrl: any,
  needAccessToken = false,
  clientId?: any
) {
  try {
    const encodeUserId = window.sessionStorage.getItem('encodeUserId')
    const encryptionValue = window.sessionStorage.getItem('encryptionString') || ''
    const userId: any = encodeUserId ? encodeUserId : ''
    const headers: any = {
      'Content-Type': 'application/json',
      storeNumber: window.sessionStorage.getItem('storeNumber') || '00000',
      clientId: clientId ? clientId : 'DOF',
      userId: userId ? userId : '3913006',
      correlationId: generate_uuidv4(),
    };
    // Only add accessToken if encryptionValue is not empty
    if (encryptionValue) {
      headers.accessToken = encryptionValue;
    }
    const requestConfig: any = {
      method: requestType,
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    };

    if (customConfig.payload) {
      requestConfig.data = customConfig.payload;
    }

    if (body) {
      requestConfig.data = JSON.stringify(body);
    }
    console.log('requestConfig', requestConfig);
    return await axios(`${apiUrl}/${endpoint}`, requestConfig).then(
      (response) => response
    );
  } catch (e: any) {
    return e.response;
  }
}




